import { useState, MouseEvent } from "react";
import { Button } from "primereact/button";

import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

import ActionBar, { Action } from "../ActionBar/ActionBar";

import S from "../_Lesson.module.scss";

const knowledgeOptions = {
  1: {
    emoticon: ":-(",
    label: "None",
  },
  2: {
    emoticon: ":-\\",
    label: "Little",
  },
  3: {
    emoticon: ":-)",
    label: "Some",
  },
  4: {
    emoticon: ":-D",
    label: "A lot",
  },
  5: {
    emoticon: "B-)",
    label: "So much",
  },
};

interface SurveyProps {
  headerText: string;
  onSubmit: (
    rating: string | null,
    isExiting?: boolean,
    event?: MouseEvent<HTMLButtonElement>
  ) => void;
  description?: string;
  isAfterLessonSurvey: boolean;
  hasNextLesson?: boolean;
  isPathCompleted?: boolean;
}

const Survey = ({
  headerText,
  onSubmit,
  description,
  isAfterLessonSurvey,
  hasNextLesson,
  isPathCompleted,
}: SurveyProps) => {
  const [rating, setRating] = useState<string | null>(null);

  const Actions: Action[] = [
    {
      ...(isAfterLessonSurvey && (isPathCompleted || hasNextLesson)
        ? {
            label: isPathCompleted ? "Finish" : "Next Lesson",
            icon: "chevron-right",
            iconPos: "right",
            onClick: event => onSubmit(rating, false, event),
          }
        : {
            label: "Confirm",
            icon: "check",
            onClick: () => onSubmit(rating),
          }),
    },
    {
      label: isAfterLessonSurvey ? "Exit" : "Skip",
      severity: "secondary",
      onClick: () => onSubmit(rating, isAfterLessonSurvey),
    },
  ];

  return (
    <div className={C(T.bgElevation2, "flex flex-col rounded-l-sm w-full")}>
      <div className={C("flex-1", T.largePaddedContainer)}>
        <h2 className="atlas-h1 mb-8 mt-6">{headerText}</h2>
        <div className="flex-1">
          <h3 className="atlas-h5 mb-4" id="rating-heading">
            Rate your knowledge
          </h3>
          <p className="atlas-h4 mb-4" id="rating-description">
            How much do you think you know about this topic?
          </p>
          <p className="body-md text-muted-aaa">{description}</p>
          <div
            className="mt-10"
            role="group"
            aria-labelledby="rating-heading"
            aria-describedby="rating-description"
          >
            {Object.entries(knowledgeOptions).map(([key, option]) => (
              <Button
                key={key}
                severity={rating === key ? undefined : "secondary"}
                className={S.learningSwingOption}
                onClick={() => setRating(key)}
                aria-pressed={rating === key}
              >
                <span>{option.emoticon}</span>
                <span>{option.label}</span>
                <span>{key}</span>
              </Button>
            ))}
          </div>
        </div>
      </div>
      <ActionBar actions={Actions} />
    </div>
  );
};

export default Survey;
